import { FloatingLabel, Form } from 'react-bootstrap';

interface EditTextProps {
  /** Floating label + placeholder. Omit to render a bare control (the caller supplies its own label, e.g. via `Field`). */
  readonly label?: string;
  readonly value: string | null;
  readonly onChange: (value: string | null) => void;
  readonly mandatory?: boolean;
}

/**
 * Multi-line text wrapper — same conventions as `EditString` but
 * renders a `Form.Control as="textarea"`. Height is fixed at 80px
 * (enough for the floating label to fit and a couple of lines of
 * content); raise to a prop if a caller needs taller. When `label` is
 * omitted the bare textarea renders and the caller owns the label.
 */
export const EditText = ({ label, value, onChange, mandatory = false }: EditTextProps) => {
  const control = (
    <Form.Control
      as="textarea"
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value === '' ? null : e.target.value)}
      placeholder={label}
      required={mandatory}
      style={{ height: '80px' }}
    />
  );
  return label ? <FloatingLabel label={mandatory ? `${label} *` : label}>{control}</FloatingLabel> : control;
};
